// Copyright (c) 2021 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

import { IState } from "states/states";
import { ActionType, IAction, raiseAction, IActionTypeEdit } from "actions";

import Rfids from "view/comp/Rfids";
import Tariffs from "view/comp/Tariffs";
import OcppChargers from "view/comp/OcppChargers";
import RefusedRfids from "view/comp/RefusedRfids";

interface IOcppConfigurationProps {}

const mapStateToProps = (state: IState) => {
  const props: IOcppConfigurationProps = {};
  return props;
};

interface IOcppConfigurationDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IOcppConfigurationDispatch = {};
  return dispatchProps;
};

class OcppConfigurationComponent extends React.Component<
  IOcppConfigurationProps & IOcppConfigurationDispatch
> {
  public render() {
    return (
      <div id="ocppconfiguration">
        <OcppChargers />
        <Rfids />
        <RefusedRfids />
        <Tariffs />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OcppConfigurationComponent);
